import enableGooglePushEvents from '@upstream/cobot_google_events';
if (window.dataLayer) {
  enableGooglePushEvents(window.dataLayer);
}
